export default {
  "Age class": [
    {
      "color": "#C7E9C0",
      "label": "PED",
      "var": "Age class",
      "var_name": "dtt.cc",
      "value": 1000,
      show: true
    },
    {
      "color": "#74C476",
      "label": "ADO",
      "var": "Age class",
      "var_name": "dtt.cc",
      "value": 1001,
      show: true
    },
    {
      "color": "#238B45",
      "label": "YA",
      "var": "Age class",
      "var_name": "dtt.cc",
      "value": 1002,
      show: true
    }
  ],
  "Cancer Group": [
    {
      "color": "#A5772B",
      "label": "(DHG) Diffuse Hemispheric Glioma",
      "var": "Cancer Group",
      "var_name": "HOPE_Cancer.Group"
      ,"value": 2001,
      show: true

    },
    {
      "color": "#1B3360",
      "label": "(DMG) Diffuse Midline Glioma",
      "var": "Cancer Group",
      "var_name": "HOPE_Cancer.Group"
      ,"value": 2002,
      show: true

    },
    {
      "color": "#4393C3",
      "label": "(HGG) High Grade Glioma (not otherwise specified)",
      "var": "Cancer Group",
      "var_name": "HOPE_Cancer.Group"
      ,"value": 2003,
      show: true

    },
    {
      "color": "#E62A8A",
      "label": "(IHG) Infantile Hemispheric Glioma",
      "var": "Cancer Group",
      "var_name": "HOPE_Cancer.Group"
      ,"value": 2004,
      show: true

    },
    {
      "color": "#660821",
      "label": "(PXA) Pleomorphic Xanthoastrocytoma",
      "var": "Cancer Group",
      "var_name": "HOPE_Cancer.Group"
      ,"value": 2005,
      show: true

    },
    {
      "color": "#F2F1F1",
      "label": "Flag",
      "var": "Cancer Group",
      "var_name": "HOPE_Cancer.Group"
      ,"value": 2006,
      show: true

    }
  ],
  "Diagnosis": [
    {
      "color": "#f268d6",
      "label": "Glioblastoma",
      "var": "Diagnosis",
      "var_name": "HARMONY_Simple.Diagnosis"
      ,"value": 3001,
      show: true

    },
    {
      "color": "#5fff57",
      "label": "Astrocytoma",
      "var": "Diagnosis",
      "var_name": "HARMONY_Simple.Diagnosis"
      ,"value": 3002,
      show: true

    },
    {
      "color": "#4393C3",
      "label": "Pleomorphic xanthoastrocytoma",
      "var": "Diagnosis",
      "var_name": "HARMONY_Diagnosis"
      ,"value": 3005,
      show: true
    },
    {
      "color": "#E62A8A",
      "label": "HGG/astrocytoma (WHO grade III/IV)",
      "var": "Diagnosis",
      "var_name": "HARMONY_Diagnosis"
      ,"value": 3006,
      show: true
      
    },
    {
      "color": "#660821",
      "label": "Diffuse Midline Glioma",
      "var": "Diagnosis",
      "var_name": "HARMONY_Diagnosis"
      ,"value": 3007,
      show: true
    },
    {
     "color": "#238B45",
      "label": "Astrocytoma;Oligoastrocytoma",
      "var": "Diagnosis",
      "var_name": "HARMONY_Diagnosis"
      ,"value": 3009,
      show: true
    }
  ],
  "Sex": [
    {
      "color": "#0707CF",
      "label": "Male",
      "var": "Sex",
      "var_name": "HARMONY_Gender"
      ,"value": 4001
      ,show: true
    },
    {
      "color": "#CC0303",
      "label": "Female",
      "var": "Sex",
      "var_name": "HARMONY_Gender"
      ,"value": 4002,
      show: true

    }
  ],
  "Tumor location": [
    {
      "color": "#94004C",
      "label": "Cerebellar",
      "var": "Tumor location",
      "var_name": "HARMONY_tumor.loc",
      "value" : 5001
    },
    {
      "color": "#D4806C",
      "label": "Cortical",
      "var": "Tumor location",
      "var_name": "HARMONY_tumor.loc",
      "value" : 5002
    },
    {
      "color": "#344C68",
      "label": "Midline",
      "var": "Tumor location",
      "var_name": "HARMONY_tumor.loc",
      "value" : 5003
    },
    {
      "color": "#7C8F97",
      "label": "Other/Multiple locations/NOS",
      "var": "Tumor location",
      "var_name": "HARMONY_tumor.loc",
      "value" : 5004
    }
  ],
  "Protein Subtype": [
    {
      "color": "#B94D3C",
      "label": "C1",
      "var": "Protein Subtype",
      "var_name": "HARMONY_Subtype",
      "value" : 6001
    },
    {
      "color": "#65B023",
      "label": "C2",
      "var": "Protein Subtype",
      "var_name": "HARMONY_Subtype",
      "value" : 6002
    },
    {
      "color": "#855F82",
      "label": "C3",
      "var": "Protein Subtype",
      "var_name": "HARMONY_Subtype",
      "value" : 6003
    }
  ],
  "Overall Survival Status": [
    {
      "label": "Dead",
      "value" : 7001
    },
    {
      "label": "Alive",
      "value" : 7002
    },
  ],
"H3-3A": [
    {
      "label": "mutated",
      "value": 9001,
      "color": "#1F77B4"  // Blue
    },
    {
      "label": "wild-type",
      "value": 9002,
      "color": "#FF7F0E"  // Orange
    }
  ],
  "ATRX": [
    {
      "label": "mutated",
      "value": 9003,
      "color": "#1F77B4"  // Blue
    },
    {
      "label": "wild-type",
      "value": 9004,
      "color": "#FF7F0E"  // Orange
    }
  ],
  "BRAF": [
    {
      "label": "mutated",
      "value": 9005,
      "color": "#1F77B4"  // Blue
    },
    {
      "label": "wild-type",
      "value": 9006,
      "color": "#FF7F0E"  // Orange
    }
  ],
  "IDH1": [
    {
      "label": "mutated",
      "value": 9007,
      "color": "#1F77B4"  // Blue
    },
    {
      "label": "wild-type",
      "value": 9008,
      "color": "#FF7F0E"  // Orange
    }
  ],
  "NF1": [
    {
      "label": "mutated",
      "value": 9009,
      "color": "#1F77B4"  // Blue
    },
    {
      "label": "wild-type",
      "value": 9010,
      "color": "#FF7F0E"  // Orange
    }
  ],
  "TP53": [
    {
      "label": "mutated",
      "value": 9011,
      "color": "#1F77B4"  // Blue
    },
    {
      "label": "wild-type",
      "value": 9012,
      "color": "#FF7F0E"  // Orange
    }
  ]
}